module.exports = __webpack_public_path__ + "img/terios.2afc5155.png";